<script setup>
import {
  NRadioGroup,
  NButton,
  NRadio,
  NInputNumber,
  NPopover,
  NInput,
  NSelect,
  NPopconfirm,
  useMessage,
  useDialog,
} from "naive-ui";
import { ref, onUnmounted, watchEffect, onMounted } from "vue";
import { getXMLData, exportXml } from "../common/index";
import { useStore } from "@/hooks/stores/global";
import { storeToRefs } from "pinia";
import { mouseEventValue, eventOptions } from "../baseData/index";
import { language } from "@/hooks/util/i18n";
import { reqInitData } from "../baseData/system";
import { reportParams,getCheckSum } from "../common/index.js";
const dialog = useDialog();
const message = useMessage();
const mouse_map = [
  { desc: "LB", value: 1 },
  { desc: "MB", value: 4 },
  { desc: "RB", value: 2 },
  { desc: "Backward", value: 8 },
  { desc: "Forward", value: 16 },
];
const main = useStore();
const { nameList, eventList, languageValue, device, currentMouse } =
  storeToRefs(main);

const isTranscribe = ref(false);

let delayTime = null;
let isUpDown = true;
// let delayTime = null;
watchEffect(
  () => {
    if (nameList.value || eventList.value) {
      localStorage.setItem(
        currentMouse.value,
        JSON.stringify({ name: nameList.value, event: eventList.value })
      );
    }
  },
  { deep: true }
);
onMounted(async () => {
  if (device.value) {
    // 读取鼠标dpi的数据
    let { reportId, reportData } = reportParams(
      reqInitData + getCheckSum(reqInitData)
    );
    // 发送数据

    await device.value.sendReport(reportId, reportData);
  }
});

onUnmounted(() => {
  main.initData("");
  main.addDpi("");
});
const handleDownUp = (evt) => {
  // console.log(evt, type);

  // console.log(evt)
  switch (evt.type) {
    case "mousedown":
      if (!isUpDown) return;
      isUpDown = false;
      if (delayTime) {
        eventList.value[nameIndex.value].push({
          value:
            nameList.value[nameIndex.value].delay_type === 1
              ? +new Date() - delayTime > 10000
                ? 10000
                : +new Date() - delayTime
              : settingDelay(),
          type: 1,
          index: eventList.value[nameIndex.value].length,
          desc:
            nameList.value[nameIndex.value].delay_type === 1
              ? `-${(+new Date() - delayTime > 10000
                  ? 10000
                  : +new Date() - delayTime
                ).toString()}ms`
              : settingDelay() + "ms",
        });
      }
      delayTime = +new Date();
      // console.log("按键按下", evt);
      eventList.value[nameIndex.value].push({
        value: mouse_map[evt.button].value,
        type: 4,
        index: eventList.value[nameIndex.value].length,
        desc: "↓" + mouse_map[evt.button].desc,
      });
      break;
    case "mouseup":
      isUpDown = true;
      if (delayTime) {
        eventList.value[nameIndex.value].push({
          value:
            nameList.value[nameIndex.value].delay_type === 1
              ? +new Date() - delayTime > 10000
                ? 10000
                : +new Date() - delayTime
              : settingDelay(),
          type: 1,
          index: eventList.value[nameIndex.value].length,
          desc:
            nameList.value[nameIndex.value].delay_type === 1
              ? `-${(+new Date() - delayTime > 10000
                  ? 10000
                  : +new Date() - delayTime
                ).toString()}ms`
              : settingDelay() + "ms",
        });
        delayTime = +new Date();
      }
      eventList.value[nameIndex.value].push({
        value: mouse_map[evt.button].value,
        type: 5,
        index: eventList.value[nameIndex.value].length,
        desc: "↑" + mouse_map[evt.button].desc,
      });
      delayTime = +new Date();
      break;
    case "keydown":
      if (!isUpDown) return;
      isUpDown = false;
      if (delayTime) {
        eventList.value[nameIndex.value].push({
          value:
            nameList.value[nameIndex.value].delay_type === 1
              ? +new Date() - delayTime > 10000
                ? 10000
                : +new Date() - delayTime
              : settingDelay(),
          type: 1,
          index: eventList.value[nameIndex.value].length,
          desc:
            nameList.value[nameIndex.value].delay_type === 1
              ? `-${(+new Date() - delayTime > 10000
                  ? 10000
                  : +new Date() - delayTime
                ).toString()}ms`
              : settingDelay() + "ms",
        });
      }

      delayTime = +new Date();
      console.log("ev", eventList.value);
      eventList.value[nameIndex.value].push({
        value: evt.keyCode,
        type: 2,
        index: eventList.value[nameIndex.value].length,
        desc: "↓" + evt.key.toUpperCase(),
      });
      break;
    case "keyup":
      // console.log(evt);
      isUpDown = true;
      if (delayTime) {
        eventList.value[nameIndex.value].push({
          value:
            nameList.value[nameIndex.value].delay_type === 1
              ? +new Date() - delayTime > 10000
                ? 10000
                : +new Date() - delayTime
              : settingDelay(),
          type: 1,
          index: eventList.value[nameIndex.value].length,
          desc:
            nameList.value[nameIndex.value].delay_type === 1
              ? `-${(+new Date() - delayTime > 10000
                  ? 10000
                  : +new Date() - delayTime
                ).toString()}ms`
              : settingDelay() + "ms",
        });
      }
      eventList.value[nameIndex.value].push({
        value: evt.keyCode,
        type: 3,
        index: eventList.value[nameIndex.value].length,
        desc: "↑" + evt.key.toUpperCase(),
      });
      delayTime = +new Date();
      break;
  }
};
const settingDelay = () => {
  switch (nameList.value[nameIndex.value].delay_type) {
    case 0:
      return 10;
    case 2:
      return nameList.value[nameIndex.value].delay_time;
  }
};
// 点击录制后的事件回调
const handleClick = () => {
  if (!nameList.value.length) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: language[languageValue.value]["请新建宏后开始录制"],
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert(language[languageValue.value]["请新建宏后开始录制"]);
    return;
  }
  isTranscribe.value = !isTranscribe.value;

  if (!isTranscribe.value) {
    window.removeEventListener("keydown", handleDownUp);
    window.removeEventListener("keyup", handleDownUp);
    // console.log(handleMouseUp);
    window.removeEventListener("mousedown", handleDownUp);
    window.removeEventListener("mouseup", handleDownUp);
    delayTime = null;
    return;
  }

  window.addEventListener("keyup", handleDownUp);
  window.addEventListener("keydown", handleDownUp);
  window.addEventListener("mouseup", handleDownUp);
  window.addEventListener("mousedown", handleDownUp);
  document
    .getElementById("removeNodeEvent")
    .addEventListener("mouseup", (event) => {
      event.stopPropagation();
    });
  document
    .getElementById("removeNodeEvent")
    .addEventListener("mousedown", (event) => {
      event.stopPropagation();
    });
};
const setting = () => {
  main.macroName({
    macro_name: `名称${nameList.value.length + 1}`,
    play_times: 1,
    macro_type: 0,
    delay_time: 0,
    delay_type: 1,
  });
  main.macroEvent([]);
};
const nameIndex = ref(0);

const nameClick = (index) => {
  if (isTranscribe.value) return;
  nameIndex.value = index;
};
const fileInput = ref();
const xmlImport = () => {
  // console.log(fileInput.value.value)
  fileInput.value.value = "";
  fileInput.value.click();
};
const inputChange = async (event) => {
  // console.log("evet", event);
  if (!event) return;
  try {
    const { macro } = await getXMLData(event);
    handleXMLData(macro);
    // console.log(macro);
    message.success("导入成功");
  } catch (err) {
    message.error("导入失败");
  }
};
const handleXMLData = (data) => {
  // console.log(data);
  const { macroitems } = data;
  const { macroinfo } = data;
  main.macroName({
    macro_name: macroinfo._attributes.macro_name,
    delay_time: Number(macroinfo._attributes.delay_time),
    delay_type: Number(macroinfo._attributes.delay_type),
    play_times: Number(macroinfo._attributes.play_times),
    macro_type: Number(macroinfo._attributes.macro_type),
  });
  nameIndex.value = nameList.value.length - 1;
  const array = [];

  for (let i = 0; i < macroitems.item.length; i++) {
    array.push({
      desc: macroitems.item[i]._attributes.desc,
      index: Number(macroitems.item[i]._attributes.index),
      value: Number(macroitems.item[i]._attributes.value),
      // timestamp: +new Date(),
      type: Number(macroitems.item[i]._attributes.type),
    });
  }
  main.macroEvent(array);
};

const exportClick = () => {
  if (!nameList.value.length) return;
  const macroinfo = {
    macroinfo: {
      _attributes: {
        ...nameList.value[nameIndex.value],
      },
    },
    macroitems: {},
  };
  macroinfo.macroitems.item = eventList.value[nameIndex.value].map(
    (item, index) => ({
      _attributes: { ...item, timestamp: index },
    })
  );

  exportXml(macroinfo);
};
const selectedEventItem = ref(-1);
const handleEventItem = (index) => {
  // console.log("index", index);
  selectedEventItem.value = index;
};
const delectEventItem = () => {
  if (selectedEventItem.value === -1) {
    return;
  }
  main.deleteEvent(nameIndex.value, selectedEventItem.value);
  selectedEventItem.value = -1;
};
const circleSetting = (value) => {
  if (!nameList.value.length) return;
  // console.log(value);
  main.updateMacroName(nameIndex.value, "macro_type", value);
  if (value !== 0) {
    main.updateMacroName(nameIndex.value, "play_times", 1);
  }
};
const delaySetting = (value) => {
  if (!nameList.value.length) return;
  main.updateMacroName(nameIndex.value, "delay_type", value);
  if (value !== 2) {
    main.updateMacroName(nameIndex.value, "delay_time", 0);
  } else {
    main.updateMacroName(nameIndex.value, "delay_time", 10);
  }
};
const delay_time = (value) => {
  main.updateMacroName(nameIndex.value, "delay_time", value);
};
const circleNum = (value) => {
  main.updateMacroName(nameIndex.value, "play_times", value);
};

const eventAttribute = (type) => {
  // console.log("type", type);
  switch (Number(type)) {
    case 1:
      return "事件延迟";
    case 2:
    case 3:
      return "键盘事件";
    case 4:
    case 5:
      return "鼠标事件";
  }
};
const eventValue = ref({
  value: "",
  desc: "",
});
const eventValueNumber = ref(1);
const currentEvent = ref(-1);
const insertEventValue = ref(0);
const eventKey = (event) => {
  // console.log(event);
  eventValue.value = {
    value: event.keyCode,
    desc: event.key.toUpperCase(),
  };
};
const keyBoardFocus = () => {
  eventValue.value = {
    value: "",
    desc: "",
  };
  window.addEventListener("keydown", eventKey);
};
const eventClick = (item, index) => {
  currentEvent.value = index;
  const { type } = item;
  if (type === 2 || type === 3) {
    eventValue.value = {
      value: item.value,
      desc: item.desc.slice(1),
    };
  } else {
    eventValueNumber.value = Number(item.value);
  }
};
const keyBoardBlur = () => {
  window.removeEventListener("keydown", eventKey);
};
const updateEvent = (index, item) => {
  currentEvent.value = -1;
  switch (item.type) {
    case 1:
      main.updateEvent(
        nameIndex.value,
        index,
        eventValueNumber.value,
        item.desc.slice(0, 1) + eventValueNumber.value + "ms"
      );

      break;
    case 2:
    case 3:
      if (!eventValue.value.desc) {
        dialog.warning({
          showIcon: false,
          closable: false,
          content: "修改值不能为空",
          positiveText: "确认",
          positiveButtonProps: {
            color: "#b5d8f1",
            textColor: "black",
            style: {
              width: "62px",
              height: "22px",
            },
          },
          style: {
            background: "#031321",
            width: "134px",
            color: "#b5d8f1",
            width: "454px",
            border: "1px solid #114b5d",
            borderRadius: "8px",
          },
        });
        // alert("修改值不能为空");
        return;
      } else {
        main.updateEvent(
          nameIndex.value,
          index,
          eventValue.value.value,
          item.desc.slice(0, 1) + eventValue.value.desc
        );
      }
      break;
    case 4:
    case 5:
      for (let i = 0; i < mouse_map.length; i++) {
        if (eventValueNumber.value === mouse_map[i].value) {
          main.updateEvent(
            nameIndex.value,
            index,
            eventValueNumber.value,
            item.desc.slice(0, 1) + mouse_map[i].desc
          );
          break;
        }
      }
      break;
  }
};
const clickoutside = () => {
  currentEvent.value = -1;
};
const insertEvent = () => {
  if (!nameList.value.length) {
    dialog.warning({
      showIcon: false,
      closable: false,
      content: "请新建宏后开始插入",
      positiveText: "确认",
      positiveButtonProps: {
        color: "#b5d8f1",
        textColor: "black",
        style: {
          width: "62px",
          height: "22px",
        },
      },
      style: {
        background: "#031321",
        width: "134px",
        color: "#b5d8f1",
        width: "454px",
        border: "1px solid #114b5d",
        borderRadius: "8px",
      },
    });
    // alert("请新建宏后开始插入");
    return;
  }
  isShowInsertPop.value = false;
  switch (insertEventValue.value) {
    case 0:
      const mouseEvent = { value: 1, type: 4, desc: "↓LB" };
      const mouseEvent1 = { value: 1, type: 5, desc: "↑LB" };
      main.insertEvent(nameIndex.value, selectedEventItem.value, mouseEvent);
      main.insertEvent(nameIndex.value, selectedEventItem.value, mouseEvent1);
      break;
    case 1:
      const keyEvent = { value: 65, type: 2, desc: "↓A" };
      const keyEvent1 = { value: 65, type: 3, desc: "↑A" };
      main.insertEvent(nameIndex.value, selectedEventItem.value, keyEvent);
      main.insertEvent(nameIndex.value, selectedEventItem.value, keyEvent1);
      break;
    case 2:
      const delayEvent = { value: 10, type: 1, desc: "-10ms" };
      main.insertEvent(nameIndex.value, selectedEventItem.value, delayEvent);
      break;
  }
};
const isShowInsertPop = ref(false);
const deleteMacroName = (index) => {
  if (isTranscribe.value) return;
  nameIndex.value = 0;
  // console.log(index,value);
  main.deleteMacroName(index);
};
const saveLastWord = ref("");
const nameUpdate = (name) => {
  if (name.length === 1) {
    saveLastWord.value = name;
  }
  main.updateMacroName(nameIndex.value, "macro_name", name);
};
const nameBlur = (event) => {
  if (event.target.value.length === 0) {
    main.updateMacroName(nameIndex.value, "macro_name", saveLastWord.value);
  }
};
</script>

<template>
  <div class="define">
    <div class="linear" style="margin-top: 24px"></div>
    <div class="top" id="removeNodeEvent">
      <n-popover>
        <template #trigger>
          <img
            src="@/images/macro-icon.png"
            alt=""
            style="cursor: pointer; margin-right: 48px"
          />
        </template>
        <span>{{ language[languageValue]["宏"] }}</span>
      </n-popover>

      <span
        class="middle"
        @click="handleClick"
        :style="{ '--bdRadius': isTranscribe ? '0px' : '10px' }"
        >{{
          language[languageValue][isTranscribe ? "暂停录制" : "开始录制"]
        }}</span
      >
    </div>
    <div>
      <div class="title" style="margin-left: 33px; margin-bottom: 3px">
        {{ language[languageValue]["宏名称"] }}
      </div>
      <div class="linear"></div>
      <div class="name" style="height: 160px">
        <div style="height: 120px; overflow: auto">
          <div
            v-for="(item, index) in nameList"
            :key="index"
            style="
              cursor: pointer;
              display: flex;
              justify-content: space-between;
            "
            class="macro_name"
            :class="{ selected: nameIndex === index }"
            @click="nameClick(index)"
          >
            <n-input
              size="tiny"
              style="
                width: 70px;
                box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
                background: linear-gradient(
                  90deg,
                  rgba(37, 91, 103, 1),
                  rgba(37, 91, 103, 1)
                );
                margin-left: 20px;
                border-radius: 3px;
                /* text-align: center; */
              "
              :value="
                item.macro_name.slice(0, 2) === '名称'
                  ? language[languageValue][item.macro_name.slice(0, 2)] +
                    item.macro_name.slice(2)
                  : item.macro_name
              "
              :maxlength="30"
              @update-value="nameUpdate"
              @blur="nameBlur"
            />
            <!-- {{ item.macro_name }} -->
            <n-popconfirm
              @positive-click="deleteMacroName(index)"
              :negative-text="language[languageValue]['取消']"
              :positive-text="language[languageValue]['确认']"
              v-if="index === nameIndex"
            >
              <template #trigger>
                <span
                  style="margin-right: 20px; display: flex; align-items: center"
                >
                  <svg
                    style="width: 20px"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 640 512"
                  >
                    <path
                      d="M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>
              </template>
              {{ language[languageValue]["是否确认删除宏"] }}
              {{
                item.macro_name.slice(0, 2) === "名称"
                  ? language[languageValue][item.macro_name.slice(0, 2)] +
                    item.macro_name.slice(2)
                  : item.macro_name
              }}
            </n-popconfirm>
          </div>
        </div>
        <div class="add">
          <span style="margin-right: 15px; cursor: pointer" @click="setting">{{
            language[languageValue]["新建"]
          }}</span>
          <span>
            <span
              style="margin-right: 15px; cursor: pointer"
              @click="xmlImport"
              >{{ language[languageValue]["导入"] }}</span
            >
            <input
              type="file"
              style="display: none"
              ref="fileInput"
              @change="inputChange"
            />
          </span>
          <span @click="exportClick" style="cursor: pointer">{{
            language[languageValue]["导出"]
          }}</span>
        </div>
      </div>
      <div class="title" style="margin: 5px 0; margin-left: 33px">
        {{ language[languageValue]["事件列表"] }}
      </div>
      <div class="linear"></div>
      <div class="name" style="height: 180px">
        <div style="display: flex">
          <span style="flex: 1">{{ language[languageValue]["序号"] }}</span>
          <span style="flex: 1">{{ language[languageValue]["值"] }}</span>
        </div>
        <div style="height: 90px; overflow: auto">
          <div
            v-for="(item, index) in eventList[nameIndex]"
            :key="item.index"
            class="eventItem"
            style="margin-bottom: 5px; height: 24px"
            @click="handleEventItem(index)"
            :class="{ bgColor: index === selectedEventItem }"
          >
            <n-popover
              trigger="click"
              placement="left-start"
              :show="index === currentEvent"
              @clickoutside="clickoutside"
            >
              <template #trigger>
                <div style="display: flex" @click="eventClick(item, index)">
                  <span style="flex: 1">{{ index }}</span>
                  <span style="flex: 1">{{ item.desc }}</span>
                </div>
              </template>
              <div class="eventPopover" style="overflow: hidden">
                <div>事件属性</div>
                <div class="key">{{ eventAttribute(item.type) }}</div>
                <div>事件值</div>

                <div style="width: 130px">
                  <n-input-number
                    v-if="item.type === 1"
                    v-model:value="eventValueNumber"
                    :max="10000"
                    size="small"
                    round
                    style="margin: 10px 0; text-align: center"
                    placeholder="只能输入数字"
                  />
                  <n-input
                    v-else-if="item.type === 2 || item.type === 3"
                    :value="eventValue.desc"
                    size="small"
                    round
                    placeholder="请输入"
                    style="margin: 10px 0; text-align: center"
                    @focus="keyBoardFocus"
                    @blur="keyBoardBlur"
                  />
                  <n-select
                    v-else
                    :options="mouseEventValue"
                    style="margin: 10px 0; text-align: center"
                    v-model:value="eventValueNumber"
                    size="small"
                  />
                </div>
                <n-button
                  type="info"
                  style="margin-top: 10px; margin-right: 20px; float: right"
                  size="tiny"
                  @click="updateEvent(index, item)"
                  >确认</n-button
                >
              </div>
            </n-popover>
          </div>
        </div>
        <div class="add">
          <n-popover
            trigger="click"
            placement="top-start"
            v-model:show="isShowInsertPop"
          >
            <template #trigger>
              <span style="margin-right: 15px; cursor: pointer">{{
                language[languageValue]["插入"]
              }}</span>
            </template>
            <div class="eventPopover" style="overflow: hidden">
              <div>事件属性</div>
              <div style="width: 130px">
                <n-select
                  :options="eventOptions"
                  style="margin: 10px 0; text-align: center"
                  v-model:value="insertEventValue"
                  size="small"
                />
              </div>
              <n-button
                type="info"
                style="margin-top: 10px; margin-right: 20px; float: right"
                size="tiny"
                @click="insertEvent"
                >确认</n-button
              >
            </div>
          </n-popover>
          <span @click="delectEventItem" style="cursor: pointer">{{
            language[languageValue]["删除"]
          }}</span>
        </div>
      </div>
      <div v-if="nameList.length" style="padding-left: 10px">
        <div class="delay" style="margin-top: 10px">
          {{ language[languageValue]["延时设置"] }}
        </div>
        <n-radio-group
          :value="Number(nameList[nameIndex].delay_type)"
          @update-value="delaySetting"
          name="radiogroup"
        >
          <div class="margin-5">
            <n-radio :value="0">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].delay_type) === 0 }"
                >{{ language[languageValue]["没有延时"] }}</span
              >
            </n-radio>
          </div>
          <div class="margin-5">
            <n-radio :value="1">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].delay_type) === 1 }"
                >{{ language[languageValue]["录制延时"] }}</span
              >
            </n-radio>
          </div>
          <div class="margin-5" style="display: flex">
            <n-radio :value="2" style="flex: 2">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].delay_type) === 2 }"
                >{{ language[languageValue]["统一延时"] }}</span
              >
            </n-radio>
            <n-input-number
              @update-value="delay_time"
              :value="nameList[nameIndex].delay_time"
              size="tiny"
              style="flex: 1"
              max="10000"
              min="10"
              :disabled="Number(nameList[nameIndex].delay_type) !== 2"
            />
            <span style="margin-left: 5px">ms</span>
          </div>
        </n-radio-group>
        <div
          style="
            width: 265px;
            height: 2px;
            margin-bottom: 8px;
            background: linear-gradient(
              90deg,
              rgba(18, 41, 55, 1),
              rgba(5, 14, 22, 1)
            );
          "
        ></div>
        <div class="delay">{{ language[languageValue]["循环设置"] }}</div>
        <n-radio-group
          @update-value="circleSetting"
          :value="Number(nameList[nameIndex].macro_type)"
          name="radiogroup"
        >
          <div class="margin-5">
            <n-radio :value="1">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].macro_type) === 1 }"
                >{{ language[languageValue]["循环直到按键松开"] }}</span
              >
            </n-radio>
          </div>
          <div class="margin-5">
            <n-radio :value="2">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].macro_type) === 2 }"
                >{{ language[languageValue]["循环直到任意按键按下"] }}</span
              >
            </n-radio>
          </div>
          <div class="margin-5">
            <n-radio :value="3">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].macro_type) === 3 }"
                >{{ language[languageValue]["循环直到触发再按下"] }}</span
              >
            </n-radio>
          </div>
          <div class="margin-5" style="display: flex">
            <n-radio :value="0" style="flex: 2">
              <span
                class="fontColor"
                :class="{ white: Number(nameList[nameIndex].macro_type) === 0 }"
                >{{ language[languageValue]["循环次数"] }}</span
              >
            </n-radio>
            <n-input-number
              @update-value="circleNum"
              :value="nameList[nameIndex].play_times"
              size="tiny"
              style="width: 85px; margin-left: 80px"
              max="255"
              min="1"
              :disabled="Number(nameList[nameIndex].macro_type) !== 0"
            />
          </div>
        </n-radio-group>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
li {
  list-style: none;
}
.define {
  color: #fff;

  width: 288px;
  font-family: "PingFang";
  .fontColor {
    color: #637077;
  }
  .delay {
    font-weight: bold;
    font-size: 14px;
    color: #b5d8f1;
  }
  .macro_name {
    width: 248px;
    height: 24px;
    // padding-left: 14px;
    box-sizing: border-box;
    border-radius: 5px;
    line-height: 24px;
    font-family: "PingFang";
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 5px;
    /deep/ .n-input {
      --n-border: 0px !important;
      --n-border-hover: 0px !important;
      --n-border-focus: 0px !important;
      margin-left: 0px !important;
    }
    // /deep/ .n-input--focus {
    //   --n-border-focus: 0px !important;
    //   --n-border-hover: 0px !important;
    // }
    /deep/ .n-input__input-el {
      color: #fff;
    }
  }
  .title {
    font-family: PingFang;
    font-weight: bold;
    font-size: 14px;
    color: #b5d8f1;
  }
  .linear {
    width: 288px;
    height: 3px;
    background: linear-gradient(90deg, #457287, #387d8c, #385d65);
  }
  .top {
    display: flex;
    align-items: center;
    background: linear-gradient(66deg, #020612, #16221e);
    margin-bottom: 12px;

    height: 64px;
    border-bottom-right-radius: 15px;
    padding: 0 18px 0 26px;
    .middle {
      position: relative;
      font-family: "PingFang";
      font-weight: bold;
      font-size: 17px;
      color: #b5d8f1;
      cursor: pointer;
      &::after {
        content: "";
        position: absolute;
        top: 8px;
        margin-left: 20px;
        width: 10px;
        height: 10px;
        background-color: red;
        border-radius: var(--bdRadius);
      }
    }
  }
  .header {
    // width: 230px;
    position: relative;
    height: 50px;
    line-height: 50px;
    border-radius: 10px;
    text-align: center;
    background-color: #15211d;
    cursor: pointer;
    &::before {
      content: "";
      position: absolute;
      top: 20px;
      margin-left: -20px;
      width: 10px;
      height: 10px;
      background-color: red;
      border-radius: var(--bdRadius);
    }
  }
  .selected {
    background: rgba(21, 58, 85, 0.22);
  }
}
.name {
  box-sizing: border-box;
  background: linear-gradient(
    90deg,
    rgba(19, 52, 71, 0.22),
    rgba(2, 12, 22, 0.22)
  );
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  position: relative;
  padding: 10px 0 0 10px;
  .add {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
.white {
  color: #fff !important;
}
.margin-5 {
  margin: 7px 0;
  /deep/ .n-radio__label {
    color: #fff;
  }
}
.delay_time {
  padding: 2px 10px;
  background-color: #102d35;
  margin-left: 80px;
  border-radius: 5px;
}
.eventItem:hover {
  background: rgba(21, 58, 85, 0.22);
  cursor: pointer;
}
.bgColor {
  background: rgba(21, 58, 85, 0.22);
}
.eventPopover {
  width: 130px;
  .key {
    width: 130px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 15px;
    margin: 10px 0;
  }
}
</style>
